import React, { useEffect, useState } from 'react';
import { FilterSelect } from '@td/ui';
import toastr from "../../toastr";
import { isNumber } from '../utils';
import { useNpCoordination } from '../context/NpCoordinationContext';
import searchNursePractitioners from '../api/searchNursePractitioners';

const NPFilter = () => {
  const [selectedNp, setSelectedNp] = useState([]);
  const { filters, setFilter, shouldClearFilters, resetClearFilters } = useNpCoordination();

  useEffect(() => {
    const newIds = selectedNp.map((value) => Number(value.value));
    if (JSON.stringify(filters.ids) !== JSON.stringify(newIds)) {
      setFilter('ids', newIds);
    }
  }, [selectedNp]);

  useEffect(() => {
    setSelectedNp([]);
    resetClearFilters();
  }, [shouldClearFilters]);


  const loadOptions = async (inputValue, callback) => {
    let npi;
    let nameSearchString;
    const value = inputValue.trim()

    if (!value) {
      callback(null)
    }

    if (isNumber(value)) {
      npi = value;
    } else {
      nameSearchString = value;
    }

    try {
      callback(
        await searchNursePractitioners(npi, nameSearchString)
      )
    } catch (e) {
      toastr.error(
        "We`re sorry, but something went wrong. Please refresh the page and try again.",
      );
    }
  };

  return (
    <FilterSelect
      async
      isMulti
      label="Nurse Practitioner"
      name="nurse_practitioner"
      onChange={(value) => setSelectedNp(value)}
      loadOptions={loadOptions}
      defaultOptions={selectedNp}
      value={selectedNp}
    />
  );
};

export default NPFilter;
